import { AxiosResponse } from "axios";

export function downloadBlobResponse(response: AxiosResponse<any, any>, defaultFilename: string) {
  const headers = response.headers;
  const contentDisposition = headers["content-disposition"];
  let filename = defaultFilename;
  if (contentDisposition) {
    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    const asciiMatch = contentDisposition.match(/filename="(.+)"/) ?? contentDisposition.match(/filename=([^;]+)/);
    if (utf8Match) {
      filename = decodeURIComponent(utf8Match[1]);
    } else if (asciiMatch) {
      filename = asciiMatch[1];
    }
  }

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  if (a.parentNode) {
    a.parentNode.removeChild(a);
  }
  window.URL.revokeObjectURL(url);
}
